module.exports = __webpack_public_path__ + "static/media/in-sync.bcc954e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/in-sync.svg
// module id = 1116
// module chunks = 1